import { message } from 'antd';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { document } from 'src/api';
import MyStore from 'kts-platform-frame/redux/MyStore';
import { reducers } from 'kts-platform-frame/redux';
import { Field } from 'kts-scaffold-framework/utils/doc';
import moment from 'moment';
import Document from "../";

class ModulesAction extends ActionBasic<ModulesState> {
    /**
     * 获取数据列表
     */
    public getData = async (recordSearch?: any) => {
        if (recordSearch) {
            this.modulesState.pageNum = recordSearch.pageNum;
            this.modulesState.pageSize = recordSearch.pageSize;
            this.modulesState.filterList = recordSearch.filterList;
            this.modulesState.saveKeyword = recordSearch.saveKeyword;
            this.modulesState.keyword = recordSearch.saveKeyword;
            this.setModulesState(this.modulesState);
        }
        const param = {
            ...this.modulesState.filterList,
            keyword: this.modulesState.saveKeyword,
            pageNum: this.modulesState.pageNum,
            pageSize: this.modulesState.pageSize,
            issueDateBegin: this.timeTotimestamp(this.modulesState.filterList.issueDateBegin),
            issueDateEnd: this.timeTotimestamp(this.modulesState.filterList.issueDateEnd),
            lastModifyTimeBegin: this.timeTotimestamp(this.modulesState.filterList.lastModifyTimeBegin),
            lastModifyTimeEnd: this.timeTotimestamp(this.modulesState.filterList.lastModifyTimeEnd),

        };
        this.modulesState.dataList = [];
        this.setModulesState(this.modulesState);
        const reData = await document.documentQuery(this, param);
        if (!reData.er && reData.res) {
            this.modulesState.dataList = reData.res.items;
            this.modulesState.pageNum = reData.res.pageMeta.pageNum;
            this.modulesState.pageSize = reData.res.pageMeta.pageSize;
            this.modulesState.total = reData.res.pageMeta.total;
            this.setModulesState(this.modulesState, () => {
                // 保存 搜索条件在 index.tsx 静态数据中
                Document.SearchDetail = {
                    saveKeyword: this.modulesState.saveKeyword,
                    keyword: this.modulesState.saveKeyword,
                    pageNum: this.modulesState.pageNum,
                    pageSize: this.modulesState.pageSize,
                    filterList: this.modulesState.filterList
                };
            });
        }
    }
    /**
     * 时间格式转时间戳
     */
    public timeTotimestamp = (val) => {
        if (val) {
            return new Date(val).valueOf();
        } else {
            return undefined;
        }
    }
    /**
     * 搜索
     */
    public searchDate = () => {
        this.modulesState.pageNum = 1;
        this.modulesState.saveKeyword = this.modulesState.keyword;
        this.setModulesState(this.modulesState);
        this.getData();
    }
    /**
     * 时间戳 转 格式日期
     */
    public timeStampToFormat = (Value: number) => {
        return Value && !isNaN(Value) ? moment(Field.formatDate(Value), this.modulesState.dateFormat) : undefined;
    }
    /**
     * 删除文档
     */
    public documentDelete = async (documentUUID: string) => {
        const param = {
            documentUUID: documentUUID,
        };
        const reData = await document.documentDelete(this, param);
        if (!reData.er) {
            message.success("删除成功");
            this.getData();
        }
    }
    /**
     * 发送文档
     */
    public documentSend = async (documentUUID: string) => {
        const param = {
            documentUUID: documentUUID,
        };
        const reData = await document.documentSend(this, param);
        if (!reData.er) {
            message.success("发送成功");
            this.getData();
        }
    }
    /**
     * 更新文档状态
     */
    public updataDocumentStatus = async (documentUUID: string, status: string, content?: string) => {
        let reData;
        if (this.modulesState.clickDocumentType === 'Invoice') {
            reData = await document.invoiceStatusUpdate(this, {
                documentUUID: documentUUID,
                status: status,
                message: content,
                isCheckout: true,
            });
        } else {
            reData = await document.documentStatusUpdate(this, {
                documentUUID: documentUUID,
                status: status,
                message: content,
            });
        }
        if (!reData.er) {
            message.success("操作成功");
            this.getData();
        }
    }
    /**
     * 右侧框 保存筛选的数据
     */
    public saveFilter = (value: any) => {
        this.modulesState.filterList = value;
        this.modulesState.pageNum = 1;
        this.setModulesState(this.modulesState, () => {
            this.getData();
            // 关闭右侧弹窗
            MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, {
                title: '筛选',
                isHide: true,
            });
        });
    }
    /**
     * 清空搜索
     */
    public restSearch = () => {
        this.modulesState.keyword = undefined;
        this.modulesState.saveKeyword = undefined;
        this.modulesState.filterList = {
            issueDateBegin: undefined,
            issueDateEnd: undefined,
            documentType: [],
            lastModifyTimeBegin: undefined,
            lastModifyTimeEnd: undefined,
            role: [],
            status: [],
            isArchived: false,
        };
        this.setModulesState(this.modulesState);
    }
    /**
     * 双向绑定 搜索
     */
    public bindKeyword = (e: any) => {
        this.modulesState.keyword = e.target.value;
        this.setModulesState(this.modulesState);
    }
    /**
     * 分页设置
     */
    public pageSet = (page: number, pageSize: number) => {
        if (pageSize !== this.modulesState.pageSize || page === 0) {
            this.modulesState.pageNum = 1;
        } else {
            this.modulesState.pageNum = page;
        }
        this.modulesState.pageSize = pageSize;
        this.setModulesState(this.modulesState, () => {
            this.getData();
        });
    }
    /**
     * 添加权限 侧边栏关闭
     */
    public closeShowPanel = () => {
        MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, {});
        // 关闭右侧弹窗
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, {
            title: '筛选',
            isHide: true,
        });
    }
    /**
     * 选择 筛选item展开/关闭
     */
    public changeSateItem = (name: string) => {
        if (name === this.modulesState.searchActive) {
            this.modulesState.searchActive = '';
        } else {
            this.modulesState.searchActive = name;
        }
        this.setModulesState(this.modulesState);
    }
    /** 新增单据类型 弹框打开/关闭 */
    public changeBillTypeM = () => {
        this.modulesState.selectBillTypeM = !this.modulesState.selectBillTypeM;
        if (this.modulesState.selectBillTypeM) {
            this.modulesState.createBillType = '';
        }
        this.setModulesState(this.modulesState);
    }
    /** 新增单据类型 选择类型 */
    public billTypeChoose = (name: string) => {
        if (name === this.modulesState.createBillType) {
            this.modulesState.createBillType = '';
        } else {
            this.modulesState.createBillType = name;
        }
        this.setModulesState(this.modulesState);
    }
    /** 拒绝 弹框打开/关闭 */
    public refuseM = (documentUUID?: string, refuseType?: string, documentType?: string) => {
        this.modulesState.clickDocumentType = documentType;
        this.modulesState.refuseType = refuseType ? refuseType : '';
        this.modulesState.selectDocumentUUID = documentUUID ? documentUUID : '';
        this.modulesState.refuseInputNum = 0;
        this.modulesState.refuseM = !this.modulesState.refuseM;
        this.setModulesState(this.modulesState);
    }
    /** 拒绝理由验证长度 */
    public checkLength = (e: any) => {
        this.modulesState.refuseInputNum = e.target.value.length;
        this.setModulesState(this.modulesState);
    }
    /** 发送之前验证文档是否符合规则 */
    public checkDocument = async (param: any) => {
        const res = await document.checkDocumentByUuid(this, param);
        return res;
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentList/Modules.Action.ts